<template>
  <div class="rescue">
    <div class="main">
      <h4 class="rescue-title">客服电话</h4>
      <div class="customer-call">
        <p class="customer-info">有任何问题欢迎电话垂询</p>
        <p class="customer-phone">
          <b>010-85927001</b> 9:00~18:00（周末与节假日除外）</p>
      </div>
      <h4 class="rescue-title">输入问题内容</h4>
      <div id="demo">
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">问题属于哪些服务</p>
          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <p>
              <label><input v-model="belong"
                       value="1"
                       type="radio"
                       name="serve">海外医疗</label>
            </p>
            <p>
              <label><input v-model="belong"
                       value="2"
                       type="radio"
                       name="serve">保险BPO</label>
            </p>
            <p>
              <label><input v-model="belong"
                       value="3"
                       type="radio"
                       name="serve">企业服务</label>
            </p>
            <p>
              <label><input v-model="belong"
                       value="4"
                       type="radio"
                       name="serve">其他</label>
            </p>
          </div>
        </div>
        <div class="ques-form"
             style="border:none;">
          <div class="ques-label">
            <p class="label-ques">问题内容</p>
            <p class="label-tip">可以多选</p>
          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <label><input v-model="content"
                     value="content1"
                     type="checkbox"
                     name="ques">请求资料</label>
            <label><input v-model="content"
                     value="content2"
                     type="checkbox"
                     name="ques">投诉</label>
            <label><input v-model="content"
                     value="content3"
                     type="checkbox"
                     name="ques">服务说明</label>
            <label><input v-model="content"
                     value="content4"
                     type="checkbox"
                     name="ques">其他</label>
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">

          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <textarea name=""
                      id=""
                      v-model="quesText"
                      cols="30"
                      rows="10"></textarea>
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">姓名</p>
          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <input v-model="username"
                   type="text"
                   style="width: 93%;">
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">所属公司名/学校名</p>
          </div>
          <span class="ques-may">任意</span>
          <div class="ques-input">
            <input type="text"
                   v-model="company">
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">所属部门</p>
          </div>
          <span class="ques-may">任意</span>
          <div class="ques-input">
            <input type="text"
                   v-model="department">
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">任职职位</p>
          </div>
          <span class="ques-may">任意</span>
          <div class="ques-input">
            <input type="text">
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">住所</p>
          </div>
          <span class="ques-may">任意</span>
          <div class="ques-input">
            <h5>邮编</h5>
            <input type="text"
                   style="">
            <h5>所在城市（市区县）</h5>
            <input type="text">
            <h5>详细地址</h5>
            <input type="text">
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">电话号码</p>
          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <input v-model="phone1"
                   type="text">
            <!-- <input v-model="phone2" type="text" style="width:25%"> —
                        <input v-model="phone3" type="text" style="width:25%;margin-right:4px">※半角数字 -->
          </div>
        </div>
        <div class="ques-form">
          <div class="ques-label">
            <p class="label-ques">电子邮箱</p>
          </div>
          <span class="ques-must">必填</span>
          <div class="ques-input">
            <input v-model="email1"
                   type="text"
                   oncut="return false"
                   oncopy="return false"
                   style="width:85%;margin-right:4px">
            <p></p>
            <input v-model="email2"
                   type="text"
                   onpaste="return false"
                   oncut="return false"
                   oncopy="return false"
                   style="width:85%;"> ※请再输入一次
          </div>
        </div>
      </div>

      <button class="ques-btn"
              @click="submitForm">提交</button>
    </div>
  </div>
</template>
<script>
import * as apis from '@/api/other'
import { verifyPhone, verifyEmail, verifyPassword } from "../../public/js/util.js";
import $ from 'jquery'
export default {
  data () {
    return {
      belong: [],
      content: [],
      username: '',
      company: '',
      department: '',
      phone1: '',
      phone2: '',
      phone3: '',
      email1: '',
      email2: '',
      quesText: ''
    }
  },
  mounted () {

  },
  methods: {
    formhtml () {
      var oldHTML = $.fn.html;
      $.fn.formhtml = function () {
        if (arguments.length) return oldHTML.apply(this, arguments);
        $("input,textarea,button", this).each(function () {
          this.setAttribute("value", this.value);
        });
        $(":radio,:checkbox", this).each(function () {
          if (this.checked) this.setAttribute("checked", "checked");
          else this.removeAttribute("checked");
        });
        $("option", this).each(function () {
          if (this.selected) this.setAttribute("selected", "selected");
          else this.removeAttribute("selected");
        });
        return oldHTML.apply(this);
      };
      let str = $('#demo').formhtml();
      // console.log(str);
      return str;
    },
    async submitForm () {
      console.log(this.formhtml())
      if (this.belong.length == 0) {
        this.$Message.error('请填写问题服务！');
        return false;
      }
      if (!this.quesText) {
        this.$Message.error('请填写问题服务！');
        return false;
      }

      if (this.content.length == 0) {
        this.$Message.error('请填写问题内容！');
        return false;
      }
      if (this.username == "") {
        this.$Message.error('请填写姓名！');
        return false;
      }
      // if (this.company == "") {
      //   this.$Message.error('所属公司名/学校名！');
      //   return false;
      // }
      // if (this.department == "") {
      //   this.$Message.error('请填写所属部门！');
      //   return false;
      // }
      if (this.phone1 == "") {
        this.$Message.error('请填写电话号码！');
        return false;
      }
      if (this.email1.trim().length == 0) {
        this.$Message.error('请填写邮箱！');
        return false;
      }
      if (this.email1 == "" || this.email2 == "") {
        this.$Message.error('请填写邮箱！');
        return false;
      }
      if (!verifyEmail(this.email1) || !verifyEmail(this.email2)) {
        this.$Message.error('邮箱格式错误！');
        return false;
      }
      if (this.email1 !== this.email2) {
        this.$Message.error('两次填写的邮箱不一致！');
        return false;
      }

      let str = this.formhtml();
      try {
        let data = {
          content: str,
          type: this.belong,
          name: this.username,
          phone: this.phone1
        }
        let res = await apis.submitProblem(data);
        if (res.code == 200) {
          this.$Message.success('提交成功！');
          this.$router.push('/home');
        } else {
          this.$Message.error('提交失败，请重试！')
        }
      } catch (e) {
        console.log(e)
      }
    }
  },

}
</script>
<style lang="less" scoped>
.rescue-title {
  padding-top: 40px;
}
.customer-call {
  margin: 0 20px;
}
.customer-info {
  font-size: 16px;
  color: #333;
  line-height: 20px;
  margin-bottom: 8px;
}
.customer-phone {
  font-size: 16px;
  color: #333;
  line-height: 24px;
}
.ques-form {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
  padding: 18px 0;
  border-bottom: 1px solid #ccc;
  .ques-label {
    width: 240px;
    .label-ques {
      font-size: 16px;
      line-height: 20px;
      color: #333;
      font-weight: bold;
    }
  }
  .ques-must {
    display: inline-block;
    width: 40px;
    height: 20px;
    background: #ae1e10;
    color: #fff;
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    border-radius: 4px;
    text-align: center;
  }
  .ques-may {
    display: inline-block;
    width: 40px;
    height: 20px;
    background: #1754a8;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    border-radius: 4px;
    text-align: center;
  }
  .ques-input {
    width: 600px;
    // font-size: 16px;
    p {
      font-size: 16px;
      color: #333;
      line-height: 20px;
      margin-bottom: 12px;
    }
    h5 {
      font-size: 16px;
      color: #333;
      line-height: 42px;
    }
    label {
      font-size: 16px;
      color: #333;
      line-height: 20px;
      margin-right: 20px;
      input[type='checkbox'] {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 6px;
      }
      input[type='radio'] {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
    input[type='text'] {
      width: 100%;
      height: 30px;
      border: 1px solid #ccc;
      text-indent: 14px;
    }
    textarea {
      width: 100%;
      height: 200px;
      font-size: 16px;
      line-height: 20px;
      padding: 20px;
    }
  }
}
.ques-btn {
  display: block;
  width: 260px;
  height: 52px;
  border: 1px solid #ae1e10;
  color: #ae1e10;
  font-size: 16px;
  border-radius: 4px;
  background: #fff;
  margin: 50px auto;
}
</style>